import { Routes, Route, useLocation } from "react-router-dom";
import UserManagement from "../../Feature/admin/userManagement/index";
import CreateUser from "../../Feature/admin/userManagement/createUser/index";
import EditUser from "../../Feature/admin/userManagement/editUser/index";
import UserView from "../../Feature/admin/userManagement/userView/index";
import { useSelector } from "react-redux";
import ApprovalDashboard from "../../Feature/admin/approvalDashboard";
import Profile from "../../Feature/admin/profile";
import ServiceSetting from "../../Feature/admin/serviceSettings";
import RBACManagementAdmin from "../../Feature/admin/rbacManagementAdmin";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/permissions";
import Notification from "../../Feature/admin/notification";
import Dashboard from "../../Feature/admin/dashboard";
import PaymentAndPayout from "../../Feature/admin/payment&Payout";
import PaymentAndHistory from "../../Feature/admin/payment&Payout/paymentAndHistory";
import ConfigurationSettings from "../../Feature/admin/configuration";
import Broadcast from "../../Feature/admin/broadcast";
import IncidentReports from "../../Feature/admin/Incedents";
import IncidentDetail from "../../Feature/admin/Incedents/incidentDetail";
import CustomerManagement from "../../Feature/admin/customerManagement";
import CustomerView from "../../Feature/admin/customerManagement/customerView";
import OrderTracking from "../../Feature/admin/orderTracking";
import OrderTrackingDetail from "../../Feature/admin/orderTracking/orderDetail";

const ProtectedRoute = ({ canAccess, children, redirectTo = "/" }) => {
  if (canAccess === undefined || canAccess) {
    return children;
  } else {
    return <Navigate to={redirectTo} replace />;
  }
};

const AdminAuth = () => {
  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];

  const canViewUserManagement = hasPermission(
    rolePermissions,
    "User Management",
    "view"
  );
  const canViewApprovalDashboard = hasPermission(
    rolePermissions,
    "Approval Dashboard",
    "view"
  );

  const canViewRBAC = hasPermission(rolePermissions, "RBAC Management", "view");

    const canViewServiceSettings = hasPermission(
    rolePermissions,
    "Service Settings",
    "view"
  );

  const canViewConfiguration = hasPermission(
    rolePermissions,
    "Configuration Settings",
    "view"
  );
    const canViewPayment$Payouts = hasPermission(
    rolePermissions,
    "Payment And Payout",
    "view"
  );
    const canViewBroadcast = hasPermission(
    rolePermissions,
    "Broadcast",
    "view"
  );
      const canViewDashboard = hasPermission(
    rolePermissions,
    "Dashboard",
    "view"
  );

  const canViewIncedents = hasPermission(
    rolePermissions,
    "Incedent Reports",
    "view"
  );
  return (
    <Routes>
        <Route
          path="/user-management"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management/create-user"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <CreateUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management/edit-user/:id"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <EditUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management/view-user"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <UserView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <CustomerManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/view/:id"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <CustomerView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-tracking"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <OrderTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-tracking/view/:id"
          element={
            <ProtectedRoute canAccess={canViewUserManagement}>
              <OrderTrackingDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rbac-management"
          element={
            <ProtectedRoute canAccess={canViewRBAC}>
              <RBACManagementAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/approval-dashboard"
          element={
            <ProtectedRoute canAccess={canViewApprovalDashboard}>
              <ApprovalDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/service-setting"
          element={
            <ProtectedRoute canAccess={canViewServiceSettings}>
              <ServiceSetting />
            </ProtectedRoute>
          }
        />

         <Route
          path="/analytics-dashboard"
          element={
            <ProtectedRoute canAccess={canViewDashboard}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        
         <Route
          path="/payment&payout"
          element={
            <ProtectedRoute canAccess={canViewPayment$Payouts}>
              <PaymentAndPayout />
            </ProtectedRoute>
          }
        />

          
         <Route
         path="/payment&payout/payment-history/:id"
          element={
            <ProtectedRoute canAccess={canViewPayment$Payouts}>
              <PaymentAndHistory />
            </ProtectedRoute>
          }
        />

            <Route
          path="/configuration-settings"
          element={
            <ProtectedRoute canAccess={canViewConfiguration}>
              <ConfigurationSettings />
            </ProtectedRoute>
          }
        />

              <Route
          path="/broadcast"
          element={
            <ProtectedRoute canAccess={canViewBroadcast}>
              <Broadcast />
            </ProtectedRoute>
          }
        />

          <Route
          path="/delivery-incedents/:incidentId"
          element={
            <ProtectedRoute canAccess={canViewIncedents}>
              <IncidentDetail />
            </ProtectedRoute>
          }
        />

          <Route
          path="/delivery-incedents"
          element={
            <ProtectedRoute
             canAccess={canViewIncedents}
             >
              <IncidentReports />
            </ProtectedRoute>
          }
        />

        <Route path="/profile" element={<Profile />} />
        <Route path="/notification" element={<Notification />} />



    </Routes>
  );
};

export default AdminAuth;
